import React from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { SubmitError } from 'Components/Fields/SubmitError';
import { FormField } from 'Components/HookFormFields/FormField';
import { useForm } from 'Hooks/useForm';
import { password, requiredPassword } from 'Utils/FormValidation';
import './EditPasswordModal.css';

export const EditPasswordModal = ({ onFormSubmit }) => {
  const formName = 'updatePasswordForm';

  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  return (
    <div>
      <div className="modalTitle">Update Password</div>
      <form className="editPasswordForm" onSubmit={(event) => handleSubmit(event)}>
        <FormField
          name="oldPassword"
          label="Current Password"
          component="PasswordField"
          validate={[requiredPassword, password]}
          autofocus
          {...formFieldProps}
        />
        <FormField
          name="newPassword"
          label="New Password"
          component="PasswordField"
          validate={[requiredPassword, password]}
          warn
          {...formFieldProps}
        />
        <SubmitError error={formError} formName={formName} />
        <div className="submitButtonContainer">
          <SubmitButton text={'Update Password'} submitting={submitting} mockDisabled={submitDisabled} />
        </div>
      </form>
    </div>
  );
};
